import { render } from "./BaseMediahubDropzone.vue?vue&type=template&id=0d7f5f43&scoped=true"
import script from "./BaseMediahubDropzone.vue?vue&type=script&lang=js"
export * from "./BaseMediahubDropzone.vue?vue&type=script&lang=js"

import "./BaseMediahubDropzone.vue?vue&type=style&index=0&id=0d7f5f43&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d7f5f43"

export default script